import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { Stack, Typography, Grid, Button } from '@mui/material';

// ----------------------------------------------------------------------

export default function HomePage() {

  return (
    <>
      <Helmet>
        <title> Home | Falcon </title>
      </Helmet>

      <Grid style={{ width: "100%", backgroundColor: 'black', display: "flex", alignItems: "center",  flexDirection: "column"  }}>

      <Grid style={{ marginTop: 30, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column",  alignItems: "center", backgroundColor: "black" }}>
            <Typography style={{ fontWeight: 700, fontSize: 36, color: '#cecece' }}>
            អស់កង្វល់ ធានាប្តូរអេក្រង់ថ្មី ១ដង iPhone 16 ស៊េរី X/A.
            </Typography>
            <Typography style={{ fontWeight: 700, fontSize: 24, color: '#cecece' }}>
            សូមធ្វើការចុះឈ្មោះ ឬស្វែករកការធានាលើការប្តូរអេក្រង់ថ្មីសម្រាប់ iPhone ស៊េរី 16 នៅទីនេះ។
            </Typography>
        </Grid>

        <Grid style={{ display: "flex", justifyContent: "center", alignItems:"center", flexDirection:"column", backgroundColor: "black" }}>
          <Grid style={{ backgroundColor: "black", padding: 15, paddingBottom: 0 }}>
            <img src="/assets/images/banners/banner-1.jpg" alt='banner1' width={800}/>
          </Grid>

          <Grid style={{ backgroundColor: "black", padding: 15, paddingBottom: 0 }}>
              <img src="/assets/falcontrust-logo.png" alt='falcontrust-logo' width={250}/>
            </Grid>
        </Grid>
        
        <Grid style={{ width: "100%", display: "flex", padding: 25,  paddingBottom: 170,
          flexDirection: "column",  alignItems: "center", backgroundColor: "black" }}>
          <Button variant="contained" style={{ width: 200, marginTop: 20 }} href={"/kh/search-screen-replacement-warranty-registration"}   disableElevation>
          ស្វែងរកការចុះឈ្មោះ
          </Button>
          <Button variant="contained" href={"/kh/cambodia-warranty-registration"} style={{ width: 200, marginTop: 20 }} disableElevation>
            ចុះឈ្មោះឥឡូវនេះ
            </Button>
        </Grid>

        
      </Grid>
    </>
  );
}
